import { useEffect } from "react";
import { TERMS_SECTIONS, TermsSection, TermsSubsection } from "../signup/termsContent";

export default function TermsPage() {
  useEffect(() => {
    document.body.style.overflow = "auto";
    document.documentElement.style.overflow = "auto";
    
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#05050F] text-white overflow-auto">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-[#0193F8] mb-2">
            Terms & Conditions and Confidentiality Agreement
          </h1>
          <p className="text-[#6B96D6]">
            FixFinder Inc. — Research Portal
          </p>
          <p className="text-[#6B96D680] text-sm mt-1">Version 2.1</p>
        </div>

        <div className="space-y-8">
          {TERMS_SECTIONS.map((section: TermsSection, index: number) => (
            <div key={index} className="border-b border-[#1e2645] pb-6 last:border-b-0">
              <h2 className="text-xl font-semibold text-[#DDEBFF] mb-4">
                {section.title}
              </h2>
              <div className="space-y-4">
                {section.subsections.map((subsection: TermsSubsection, subIndex: number) => (
                  <div key={subIndex}>
                    {subsection.heading && (
                      <h3 className="text-[#0193F8] font-medium mb-2">
                        {subsection.heading}
                      </h3>
                    )}
                    <ul className="space-y-2">
                      {subsection.items.map((item: string, itemIndex: number) => (
                        <li
                          key={itemIndex}
                          className="text-[#9cb3d8] text-[15px] leading-relaxed pl-4 relative before:content-['•'] before:absolute before:left-0 before:text-[#0193F8]"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-[#1e2645] text-center">
          <p className="text-[#6B96D680] text-sm">
            © 2026 FixFinder Inc. All rights reserved.
          </p>
          <a
            href="/"
            className="text-[#0193F8] hover:underline text-sm mt-2 inline-block"
          >
            Back to Portal
          </a>
        </div>
      </div>
    </div>
  );
}
